import React, { useRef } from 'react';
import {
  TextInput,
  DateTimePickerField,
  SelectInput,
  CheckBoxField,
} from '../../../../layouts/FormElement';

import { LoadingButton } from '@mui/lab';
import { Box, Grid, MenuItem, Button, Typography } from '@mui/material';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { API_URL } from '../../../../../../links/API_LINKS';
import { useQueryClient } from 'react-query';

const EditEvent = ({ event, snackbarActions, handleClose, currentBatch }) => {
  const queryClient = useQueryClient();
  const { setSnackbarText, setSnackbarSeverity, setSnackbarOpen } =
    snackbarActions;
  const formikRef = useRef();
  return (
    <div>
      <Formik
        enableReinitialize={true}
        innerRef={formikRef}
        initialValues={{
          eventId: event._id,
          batch: event.batch,
          title: event.title,
          type: event.type,
          week: event.week,
          description: event.description,
          imageUrl: event.imageUrl,
          dateTime: event.dateTime,
          link: event.link,
          onlineOrOffline: event.onlineOrOffline,
          status: event.status,
          recordingUrl: event.recordingUrl || '',
          resources: event.resources || [],
          pollingEvent: event.pollingEvent || false,
        }}
        validationSchema={Yup.object({
          link: Yup.string().url().required('link is required'),
          week: Yup.number().required('Week is required'),
          title: Yup.string().required('Title is required'),
          imageUrl: Yup.string().url().required('image is required'),
          resources: Yup.array().of(
            Yup.object().shape({
              title: Yup.string().required('Title is required'),
              link: Yup.string().url().required('Link is required'),
            })
          ),
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          axios({
            method: 'PUT',
            url: API_URL + '/event',
            data: values,
          })
            .then(function (response) {
              setSnackbarText('Event edited successfully');
              setSnackbarSeverity('success');
              setSnackbarOpen(true);
              setSubmitting(false);
              queryClient.invalidateQueries(
                `fetchCurrentBatchEvents${event.batch}`
              );
              handleClose();
            })
            .catch(function (response) {
              setSnackbarText('Failed to Edit Events');
              setSnackbarSeverity('error');
              setSnackbarOpen(true);
              setSubmitting(false);
            });
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => (
          <Form>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 2, sm: 1, md: 5 }}
              mb={3}
            >
              {' '}
              <Grid item xs={12} sm={6}>
                <TextInput
                  size='small'
                  fullWidth
                  name='title'
                  type='text'
                  label='Title'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput
                  fullWidth
                  name='week'
                  type='number'
                  label='Week'
                  size='small'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput
                  fullWidth
                  multiline
                  rows={3}
                  name='description'
                  type='text'
                  label='Description'
                  size='small'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput
                  size='small'
                  fullWidth
                  name='imageUrl'
                  type='text'
                  label='Image'
                />
                <div>
                  <img src={values.imageUrl} alt='' width='150' />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <DateTimePickerField
                  name='dateTime'
                  value={values.dateTime}
                  label='Event Date'
                  onChange={setFieldValue}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput
                  size='small'
                  fullWidth
                  name='link'
                  type='text'
                  label='Link'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput
                  size='small'
                  fullWidth
                  name='status'
                  label='Status'
                >
                  <MenuItem value='publish'>Publish</MenuItem>
                  <MenuItem value='draft'>Draft</MenuItem>
                </SelectInput>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput
                  size='small'
                  fullWidth
                  name='recordingUrl'
                  type='text'
                  label='Recording Url'
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CheckBoxField name='pollingEvent' label='Polling in Event' />
              </Grid>
              <Grid item xs={12}>
                <FieldArray
                  name='resources'
                  render={(arrayHelpers) => (
                    <>
                      <div style={{ display: 'flex' }}>
                        <Typography variant='h6'>Resources</Typography>

                        <Button
                          type='button'
                          onClick={() =>
                            arrayHelpers.push({
                              title: '',
                              link: '',
                            })
                          }
                        >
                          +ADD
                        </Button>
                      </div>
                      {values.resources.map((content, index) => {
                        return (
                          <Box
                            sx={{
                              backgroundColor: 'primary.light',
                              padding: '20px',
                              border: '1px solid',
                              borderColor: 'primary.main',
                              borderRadius: '2px',
                              marginY: '10px',
                            }}
                          >
                            <Grid
                              container
                              rowSpacing={3}
                              columnSpacing={{ xs: 2, sm: 1, md: 5 }}
                              mb={3}
                            >
                              {' '}
                              <Grid item xs={12} sm={5}>
                                <TextInput
                                  size='small'
                                  fullWidth
                                  name={`resources[${index}].link`}
                                  type='text'
                                  label='Link'
                                />
                              </Grid>
                              <Grid item xs={12} sm={5}>
                                <TextInput
                                  size='small'
                                  fullWidth
                                  name={`resources[${index}].title`}
                                  type='text'
                                  label='Title'
                                />
                              </Grid>
                              <Grid item xs={12} sm={2}>
                                <Button
                                  type='button'
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  -Remove
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        );
                      })}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                p: 1,
                m: 1,
              }}
            >
              <LoadingButton
                size='large'
                type='submit'
                variant='contained'
                loading={isSubmitting}
              >
                Update Event
              </LoadingButton>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditEvent;
